export default __webpack_public_path__ + "menu-reports-icon.1b4db30084e18a77247f0c45ab0dd7eb.svg";